export * from "./shared";

/**
 * WEB variant — the TWO restriction codes `apps/web/src/utils/restrictionConstants.ts`
 * declares and `apps/mobile`'s copy does not. Verbatim from web.
 *
 * They are web-only because the mobile app has neither feature wired up, not because the codes
 * mean something different there. If mobile ever gains one, move it to `./shared.ts` rather
 * than declaring a second copy here.
 */
export const POST_FINAL_INVENTORY_ACTIVITY = "POST_FINAL_INVENTORY_ACTIVITY";
export const CASH_DRAWER_ACCESS = "CASH_DRAWER";
